import type { KeywordGrade } from '@keywordgod/shared';
import { cn } from '@/lib/utils';

const GRADE_STYLE: Record<
  KeywordGrade,
  { bg: string; text: string; ring?: string; shimmer?: boolean }
> = {
  'S+': { bg: 'bg-gradient-to-br from-[#FFF066] to-[#FFA500]', text: 'text-black', ring: 'ring-2 ring-gold/60', shimmer: true },
  S:   { bg: 'bg-gradient-to-br from-[#FFD700] to-[#FFA500]', text: 'text-black', ring: 'ring-1 ring-gold/40', shimmer: true },
  'A+':{ bg: 'bg-emerald-500', text: 'text-black' },
  A:   { bg: 'bg-emerald-600', text: 'text-white' },
  'B+':{ bg: 'bg-blue-500', text: 'text-white' },
  B:   { bg: 'bg-blue-600', text: 'text-white' },
  'C+':{ bg: 'bg-amber-500', text: 'text-black' },
  C:   { bg: 'bg-amber-600', text: 'text-white' },
  D:   { bg: 'bg-red-600', text: 'text-white' },
};

export type ScoreBadgeSize = 'sm' | 'md' | 'lg' | 'xl';

const SIZE: Record<ScoreBadgeSize, string> = {
  sm: 'h-6 min-w-[2.25rem] px-2 text-xs',
  md: 'h-7 min-w-[2.5rem]  px-2.5 text-sm',
  lg: 'h-9 min-w-[3rem]    px-3 text-base',
  xl: 'h-12 min-w-[4rem]   px-4 text-xl',
};

export function ScoreBadge({
  grade,
  size = 'md',
  className,
}: {
  grade: KeywordGrade;
  size?: ScoreBadgeSize;
  className?: string;
}) {
  const s = GRADE_STYLE[grade];
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded-lg font-extrabold leading-none',
        s.bg,
        s.text,
        s.ring,
        s.shimmer && 'animate-shimmer',
        SIZE[size],
        className,
      )}
    >
      {grade}
    </span>
  );
}
